import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  TextField,
  makeStyles,
} from '@material-ui/core';
import React, { useEffect, useState } from 'react';

const useStyles = makeStyles({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-evenly',
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    width: '50%',
  },
  checkbox: {
    margin: '0 auto',
  },
  input: {
    width: '100%',
    height: '100%',
    margin: '10px 0',
  },
  formSpan: {
    marginTop: '10px',
    fontFamily: 'Roboto',
    fontSize: '15px',
    color: '#888',
    textAlign: 'center',
  },
});

export const Maintenance = () => {
  const classes = useStyles();

  const [state, setState] = useState({
    maintenance: false,
    message: '',
    sent: false,
    error: false,
  });

  useEffect(() => {
    const fetchMaintenance = async () => {
      try {
        const response = await fetch(
          'https://api.edicionesmilenio.com/api/maintenance-mode'
        );
        const data = await response.json();

        setState({
          maintenance: data?.status || false,
          message: data?.message || '',
        });
      } catch (error) {
        console.error(error);
      }
    };

    fetchMaintenance();
  }, []);

  useEffect(() => {
    !state.maintenance && state.message && setState({ ...state, message: '' });
  }, [state, state.maintenance]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = state.maintenance
        ? await fetch(
            'https://api.edicionesmilenio.com/api/maintenance-mode/activate',
            {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({ message: state.message.trim() }),
            }
          )
        : await fetch(
            'https://api.edicionesmilenio.com/api/maintenance-mode/deactivate',
            {
              method: 'PUT',
              headers: {
                'Content-Type': 'application/json',
              },
            }
          );

      if (!response.ok) {
        throw new Error('Error al realizar la operación.');
      }

      setState({ ...state, sent: true, error: false });
    } catch (error) {
      console.error(error);
      setState({ ...state, error: true, sent: false });
    }
  };

  return (
    <div className={classes.container} style={{ width: '100%' }}>
      <form className={classes.form} noValidate autoComplete="off">
        <p className={classes.formSpan}>
          Estimado administrador, desde esta sección podrás definir el estado y
          mensaje de mantenimiento (máximo 200 caracteres) a mostrar en la
          plataforma publica.
        </p>
        <FormControlLabel
          control={
            <Checkbox
              checked={state.maintenance}
              onChange={(e) =>
                setState({
                  ...state,
                  maintenance: e.target.checked,
                  sent: false,
                  error: false,
                })
              }
              name="maintenance"
              id="maintenance"
              color="primary"
            />
          }
          htmlFor="maintenance"
          label="En mantenimiento"
          className={classes.checkbox}
        />
        {state.maintenance && (
          <Box
            style={{
              position: 'relative',
              width: '100%',
              height: '100%',
            }}
          >
            <div
              style={{
                position: 'absolute',
                bottom: '10%',
                right: '5px',
                opacity: '0.5',
                zIndex: '1',
              }}
            >
              {state.message.trim().length}/200 caracteres
            </div>
            <TextField
              multiline
              minRows={4}
              className={classes.input}
              value={state.message}
              onChange={(e) =>
                setState({
                  ...state,
                  message: e.target.value.substring(0, 200),
                  sent: false,
                  error: false,
                })
              }
              id="outlined-basic"
              label="Mensaje de mantenimiento"
              variant="outlined"
            />
          </Box>
        )}
        {state.sent && (
          <p className={classes.formSpan} style={{ color: 'green' }}>
            {state.maintenance
              ? 'Mantenimiento activado.'
              : 'Mantenimiento desactivado.'}
          </p>
        )}
        {state.error && (
          <p className={classes.formSpan} style={{ color: 'red' }}>
            {state.maintenance && !state.message
              ? 'Debe ingresar un mensaje.'
              : 'No se pudo realizar la operación, intente nuevamente más tarde.'}
          </p>
        )}
        <Button
          variant="contained"
          color="primary"
          size="large"
          className={classes.button}
          onClick={(e) => {
            if (state.maintenance && !state.message.trim()) {
              e.preventDefault();
              setState({ ...state, error: true, sent: false });
            } else {
              handleSubmit(e);
            }
          }}
        >
          Guardar
        </Button>
      </form>
    </div>
  );
};
